// schema generated by dev/build
import {data as schema} from '../../../../../public/_graphql/default.types.graphql.json';

/**
 * config for urql cache exchange
 * primarily used for the keys config to ignore the warning for _extend usage
 */
export default {
  keys: {
    SiteTreeInterfaceConnection1: () => null,
  },
  schema,
};
